import { createUseStyles } from "$utils/createUseStyles";

export const useStyles = createUseStyles(() => ({
  errorContainer: {
    color: "#ef7c83",
    marginTop: 20,
    marginBottom: 20,
    display: "flex",
  },
  newFormFieldsRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
    marginTop: 20,
  },
  newFormFieldsCol: {
    flex: 1,
    maxWidth: "48%",
  },
}));
